import { render, staticRenderFns } from "./GestionBodegaDetalleCombos.vue?vue&type=template&id=b753d9d4&scoped=true"
import script from "./GestionBodegaDetalleCombos.vue?vue&type=script&lang=js"
export * from "./GestionBodegaDetalleCombos.vue?vue&type=script&lang=js"
import style0 from "./GestionBodegaDetalleCombos.vue?vue&type=style&index=0&id=b753d9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b753d9d4",
  null
  
)

export default component.exports